import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Dashboard from "./Dashboard";
import Login from "./Login";
import Signup from "./Signup";
import ProtectedRoute from "./ProtectedRoute";
import TeamSelectionPage from "./TeamSelectionPage";
import NotFound from "./NotFound";
import MyProfile from "./MyProfile";
import BattlepassPage from "./BattlepassPage";
import SignupConfirmation from "./SignupConfirmation";
import EmptyDashboard from "./EmptyDashboard";
import RegionSelectPage from "./RegionSelect";
import CareerPage from "./CareerPage";
import TeamBuilderPage from "./TeamBuilderPage";
import PreMatchPrepPage from "./PreMatchPrepPage";
import TrainingCenter from "./TrainingCenter";
import MatchupPage from "./MatchupPage";
import TransferMarketPage from "./TransferMarketPage";
import MatchPredictions from "./MatchPredictions";
import AroundTheLeague from "./AroundTheLeague";
import ResetPassword from "./ResetPassword";
import BattlepassRewardsPageEmpty from "./BattlepassPageEmpty";
import GlobalLeaderboard from "./GlobalLeaderboard";
import MatchHistory from "./MatchHistoryPage";
import Collection from "./Collection";
// import Maintenance from "./Maintenance";
import PlayerStatsPage from "./PlayerStatsPage";

function App() {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Router>
        <Routes>
          {/* <Route path="*" element={<Maintenance />} /> */}
           <Route path="/" element={<EmptyDashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/email-successful" element={<SignupConfirmation />} />
           <Route
            path="/team-selection"
            element={
              <ProtectedRoute>
                <TeamSelectionPage />
              </ProtectedRoute>
            }
          />
          <Route path="/leaderboard/yearly" element={<GlobalLeaderboard />} />
          <Route
            path="/league/:leagueId/market"
            element={
              <ProtectedRoute>
                <TransferMarketPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/league/:leagueId/pickems"
            element={
              <ProtectedRoute>
                <MatchPredictions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/me"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/league/:leagueId/history/:matchId?"
            element={
              <ProtectedRoute>
                <MatchHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/league/:leagueId/player/:playerId"
            element={
              <ProtectedRoute>
                <PlayerStatsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rewards/:leagueId"
            element={
              <ProtectedRoute>
                <BattlepassPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rewards"
            element={
              <ProtectedRoute>
                <BattlepassRewardsPageEmpty />
              </ProtectedRoute>
            }
          />
          <Route
            path="/around-the-league/:leagueId"
            element={
              <ProtectedRoute>
                <AroundTheLeague />
              </ProtectedRoute>
            }
          />
          <Route
            path="/choose-region"
            element={
              <ProtectedRoute>
                <RegionSelectPage />
              </ProtectedRoute>
            }
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/career"
            element={
              <ProtectedRoute>
                <CareerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/league/:leagueId"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/league/:leagueId/build"
            element={
              <ProtectedRoute>
                <TeamBuilderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/league/:leagueId/prep"
            element={
              <ProtectedRoute>
                <PreMatchPrepPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/league/:leagueId/matchup/:matchupId"
            element={
              <ProtectedRoute>
                <MatchupPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/league/:leagueId/collection"
            element={
              <ProtectedRoute>
                <Collection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/collection"
            element={
              <ProtectedRoute>
                <Collection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/league/:leagueId/train"
            element={
              <ProtectedRoute>
                <TrainingCenter />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
